import React from 'react';

type Props = {
  isLoading?: boolean,
  style?: React.CSSProperties,
};

const AppLoading: React.FC<Props> = ({ isLoading = true, style }) => {
  return isLoading ? (
    <div className='loading-container' style={style}>
      <div className='spinner'>
        <div className='spinner-segment'></div>
        <div className='spinner-segment'></div>
        <div className='spinner-segment'></div>
      </div>
      <p className='loading-text'>Loading<span className='dots'></span></p>
    </div>
  ) : <></>;
};

export default AppLoading;